export default "__VITE_ASSET__C$EbvEaX__"